<!--
  --
  -- パスワード設定 ページ
  --
  -->
<template>
  <c-container form>
    <c-password-group
      @confirmed="onConfirmed"
    >
      <!-- タイトル -->
      <template #title>パスワードを設定</template>

      <!-- 説明文 -->
      <template>
        <p>
          パスワードを入力して下さい。
        </p>
      </template>

      <template #submit-text>パスワードを設定</template>
    </c-password-group>

    <!-- タイムアウト制御 -->
    <c-timeout/>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CPasswordGroup from './CPasswordGroup'
import CTimeout from '../CTimeout'

import { run } from '@/libs/a'

export default {
  name: 'Password',
  mixins: [
    page('パスワードを設定')
  ],
  components: {
    CPasswordGroup,
    CTimeout
  },
  methods: {
    /**
     * パスワードが確認された
     *
     * @param {String} password 入力されたパスワード
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onConfirmed (password, failed) {
      run(async () => {
        // store にメールアドレスを保存する
        this.commit('register/setPassword', password)

        // 次のページへ
        await this.goTo({ name: 'register/profile' })
      })
    }
  }
}
</script>
